import { Entity } from '@backstage/catalog-model';

const CLOUDBUILD_FILTER_REPO_STRING = 'substitutions.REPO_NAME=';
const CLOUDBUILD_FILTER_REPO_ANNOTATION = 'google.com/cloudbuild-repo-name';
const CLOUDBUILD_FILTER_TRIGGER_STRING = 'substitutions.TRIGGER_NAME=';
const CLOUDBUILD_FILTER_TRIGGER_ANNOTATION =
  'google.com/cloudbuild-trigger-name';

/** @public */

export const getCloudbuildFilter = (entity: Entity) => {
  const repoAnnotation =
    entity?.metadata.annotations?.[CLOUDBUILD_FILTER_REPO_ANNOTATION] ?? '';
  const triggerAnnotation =
    entity?.metadata.annotations?.[CLOUDBUILD_FILTER_TRIGGER_ANNOTATION] ?? '';
  if (repoAnnotation) {
    const cloudbuildFilter = CLOUDBUILD_FILTER_REPO_STRING + repoAnnotation;
    return cloudbuildFilter;
  } else if (triggerAnnotation) {
    const cloudbuildFilter =
      CLOUDBUILD_FILTER_TRIGGER_STRING + triggerAnnotation;
    return cloudbuildFilter;
  }
  const entityName = entity?.metadata.name ?? '';
  const cloudbuildFilter = CLOUDBUILD_FILTER_REPO_STRING + entityName;
  return cloudbuildFilter;
};

export const getRepoAnnotation = (entity: Entity): string => {
  return (
    entity?.metadata.annotations?.[CLOUDBUILD_FILTER_REPO_ANNOTATION] ?? ''
  );
};
